import { EntityType } from '~/enums/EntityType';
import { sylvanus } from '~/services/serviceInstances';
import { EntityQuery } from '~/types/OpenSearch';

import {
  PromptModelDocsInScope,
  SearchScope,
} from '../../types/sylvanus/model';
import { withQueryFormat } from './searchScopeUtils';

type SearchQuery = EntityQuery[];

export const getDocsInScope = async ({
  entityId,
  entityType,
  query,
}: {
  entityId: string;
  entityType: EntityType.Field | EntityType.DocumentAttachedData;
  query: SearchQuery;
}): Promise<number> => {
  const scope: SearchScope = {
    data: {
      attributes: {
        filters: [],
        query: withQueryFormat(query),
        store_as_recent_search: false,
      },
    },
    type: 'document',
  };
  const response: PromptModelDocsInScope = await sylvanus.post(
    `/model/docs-in-scope`,
    {
      target_entity: {
        id: entityId,
        type: entityType,
      },
      scope,
    },
  );
  return response.docs_in_scope;
};
